import * as actions from "../action.constants";

const initialState = {
  jobsData: {},
  selectedJob: {},
};

const saveJobs = (state, action) => {
  return {
    ...state,
    jobsData: action.payload,
  };
};

const saveJob = (state, action) => {
  return {
    ...state,
    selectedJob: action.payload,
  };
};

const handlers = {
  [actions.STORE_JOBS]: saveJobs,
  [actions.STORE_JOB]: saveJob,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
